import React from 'react';
import { Routes, Route} from 'react-router-dom';
import Home from '../components/user/Home';
import Done from '../components/user/Done';
import Leaderboard from '../components/user/Leaderboard';

const UserBattle = () => (
  <div>
    <Routes>
      {/* Route for Login */}
     
      <Route path="home" element={<Home />} />
      <Route path="done" element={<Done />} />
    </Routes>
  </div>
);

export default UserBattle;
